var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C4.97569 2 1 5.63257 1 10C1 14.3674 4.97569 18 10 18C11.2129 18 12.368 17.7868 13.4216 17.4013C13.7957 17.2645 14.222 17.2638 14.6051 17.4391L17.2869 18.6663C17.6707 18.8419 18.086 18.4924 17.9785 18.0843L17.3293 15.6191C17.206 15.1505 17.3225 14.6715 17.5868 14.3043C18.4837 13.0583 19 11.5816 19 10C19 5.63257 15.0243 2 10 2ZM0 10C0 4.97859 4.5309 1 10 1C15.4691 1 20 4.97859 20 10C20 11.8053 19.4093 13.4841 18.3984 14.8885C18.2894 15.04 18.257 15.215 18.2964 15.3644L18.9455 17.8296C19.2679 19.054 18.0221 20.1024 16.8708 19.5756L14.189 18.3484C14.0658 18.292 13.9139 18.286 13.7652 18.3405C12.6018 18.7661 11.3304 19 10 19C4.5309 19 0 15.0214 0 10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.9cdc57a92131d95043a2d90e5e4b420a.svg";
export { ForwardRef as ReactComponent };